/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TypePolicies } from '@apollo/client';

const RoleCacheTypePolicies: TypePolicies = {
  Role: {
    keyFields: ['id'],
    fields: {
      parent: {
        merge(existing = null, incoming) {
          return incoming === null ? existing : incoming;
        },
      },
      permissions: {
        merge(existing = [], incoming) {
          return incoming === null ? existing : incoming;
        },
      },
      teams: {
        merge(existing = [], incoming) {
          return incoming === null ? existing : incoming;
        },
      },
    },
  },
  Query: {
    fields: {
      getRolePermissionFormData: {
        merge(existing = null, incoming) {
          return incoming === null ? existing : incoming;
        },
      },
    },
  },
};

export { RoleCacheTypePolicies };
